const RE_LOGIN_REQUIRED_KEY = 'zenid.re_login_required';

/**
 * アカウント統合の失敗後は Auth0 テナントセッションが追加ログインしたアカウントに切り替わったまま残るため、
 * サイレント認証でそのセッションを引き継がず、明示的な再ログインを要求するためのフラグ
 */
export function markReLoginRequired(): void {
  sessionStorage.setItem(RE_LOGIN_REQUIRED_KEY, '1');
}

export function consumeReLoginRequired(): boolean {
  const required = sessionStorage.getItem(RE_LOGIN_REQUIRED_KEY) !== null;
  sessionStorage.removeItem(RE_LOGIN_REQUIRED_KEY);
  return required;
}
